import {commentType} from "@/utils/commentType";
import {getCategoryListByTopicApi, getCategory1ListByTopicApi} from "@/api/admin/categoryApi";
import {
    clearTopicApi,
    deleteGoodsApi,
    getSelectedPageApi,
    updateSortApi,
    getSelectedTotalApi,
    getGoodsPriceTrendApi,
    updateTopicGoodsDisPriceApi,
    loadSimilarProductsApi,
    batchSaveProductsApi, getTopicListApi, batchEditProductsApi, updateMarketPriceApi
} from "@/api/admin/topicApi";
import {editDisPriceApi} from "@/api/backend/goodsManageApi.js";
import {exportExcelApi} from "@/api/backend/export"
import ObjectUtil from "@/utils/ObjectUtil";
import SelGoods from "@/views/SelectGoods/components/SelGoods/index.vue";
import sd from "silly-datetime";
import {findBackendJdRegionApi, getGoodsDetailByIdsApi} from "@/api/backend/addressApi";
import JdAddressListDelivery from "@/components/JdAddressListDelivery/index.vue";

/**
 * 选品商品
 */
export const mixins = {
    name: "SelGoods",
    data() {
        return {
            parentDialogVisible: false,
            selectedAddresses: JSON.parse(localStorage.getItem('selectedAddresses')) || {},
            dialog: false,
            item: {},
            index: 1,
            addressDialog: false,
            selectionGoods: {
                status: 1,
                supplyRate: "",
                scribingType: "",
                scribingRatio: 0.8,
                topicId: "",
                commentType: "",
                goodsId: "",
                current: 1,
                size: 10,
                total: 999,
                isJd: 1,
                title: "",
                categoryId1Name: "",
                categoryId2Name: "",
                level: "",
                phone: "",
                minSupplyPrice: "",
                maxSupplyPrice: "",
                minProfitMargin: "",
                maxProfitMargin: "",
                priceSort: "",
                sortOrder: [],
                addressMapList: {},
                fromTopic: ""
            },
            categoryId1: [],
            categoryId2: [],
            selectGoods: [],
            total: 999,
            loading: false,
            excelLoading: false,
            idArr: [],
            addressObj: {
                provinceId: "",
                cityId: "",
                countyId: "",
                townId: ""
            },
            addressList: {
                provinceList: [],
                cityList: [],
                countyList: [],
                townList: []
            },
            skuListFiler: [],
            selGoodsList: [],
            rate: 1.25,
            jdRate: 0.98,
            systemRate: 0.800,
            chartDialogVisible: false,
            chartData: {},
            childData: {}, // 存储所有子表格数据，结构：{ 父id: [子数据1, 子数据2] }
            topicListVo: [],
            topicVisible: false,
            moveTopicId: ''
        };
    },
    components: {SelGoods, JdAddressListDelivery},
    props: {
        items: {}
    },
    computed: {},
    filters: {},
    methods: {
        async getListTopic() {
            let {data} = await getTopicListApi();
            this.topicListVo = data;
        },
        closeTopicVisible() {
            this.topicVisible = false
            this.topicListVo = []
            this.moveTopicId = ''
        },
        async openTopicVisible() {
            this.topicVisible = true
            await this.getListTopic();
        },
        async editNewProductOfChoice(steps) {
            if (!steps || steps < 1) {
                this.$message.error('请选择步骤数')
                return;
            }
            /*if (steps === 1) {
                this.topicVisible = true
                await this.getListTopic();
                return;
            }*/
            let topicId = this.item.id
            let moveTopicId = this.moveTopicId
            let dtoList = this.idArr.map(item => {
                return {
                    goodsId: item
                };
            })
            let data = {
                dtoList,
                moveTopicId,
                topicId
            }
            this.$confirm('此操作将转移商品到指定的选品库，是否确认继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await batchEditProductsApi(data);
                if (res.msg === "success") {
                    this.$message.success('添加成功')
                } else {
                    this.$message({
                        type: 'success',
                        message: '添加失败!'
                    });
                }
                this.queryGetList();
                this.closeTopicVisible()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消添加'
                });
            });
        },
        async loadSimilarProducts(item, expend) {
            if (expend) {
                try {
                    // 避免重复加载
                    if (this.childData[item.id]?.data) return;

                    // 显示加载状态
                    this.$set(this.childData, item.id, {
                        loading: true,
                        data: []
                    });
                    // 正确调用API方法
                    const response = await loadSimilarProductsApi(item);
                    console.log(response)
                    console.log(response.data)
                    let apiData = []
                    // 正确提取数据数组
                    if (response.data) {
                        apiData = response.data;
                    }
                    // 确保获取数组数据
                    console.log(apiData)
                    this.$set(this.childData, item.id, {
                        loading: false,
                        data: apiData.map(child => ({
                            ...child,
                            _level: (item._level || 0) + 1 // 添加层级标记
                        }))
                    });
                    console.log(this.childData)
                } catch (error) {
                    this.$set(this.childData, item.id, {
                        loading: false,
                        data: []
                    });
                    this.$message.error('加载失败');
                }
            }
        },
        openSearchTab(item) {
            let searchKeyword;
            if (item.searchKeyword) {
                searchKeyword = item.searchKeyword;
            } else {
                searchKeyword = item.title.substring(0, item.title.length / 2);
            }

            // 生成跟踪参数
            const urlParams = this.generateJdUrlParams(item.position || 1);

            // 打开新的搜索标签页，附加上生成的跟踪参数
            window.open(
                `https://search.jd.com/Search?keyword=${encodeURIComponent(searchKeyword)}&${urlParams}`,
                '_blank'
            );
        },
        /*openSearchTab(item) {
            let searchKeyword;
            if (item.searchKeyword) {
                searchKeyword = item.searchKeyword
            } else {
                searchKeyword = item.title.substring(0, item.title.length / 2)
            }
            // let title = item.title.substring(0,item.title.length / 2)
            // 打开新的搜索标签页
            window.open(
                `https://search.jd.com/Search?keyword=${encodeURIComponent(searchKeyword)}`,
                '_blank'
            );
            // window.open(
            //     `https://apollo-evaluate.jd.com/?jdreactkey=JDReactEvaluateModule&jdreactapp=JDReactEvaluateModule&page=EvaluateListWrapper&sku=${encodeURIComponent(item.skuId)}&showSkuChange=true&isCurrentSku=true&selectBorderColor=%23FF4500&selectBackgroundColor=%23FF4500&borderColor=%23F5FFFA&backgroundColor=#F5FFFA&hiddenH5Nav=1`,
            //     '_blank'
            // );
        },*/
            // 模仿生成 spmTag 和 pvid 的函数
        generateJdUrlParams(position = 1) {
            // 1. 生成 spmTag
            // 固定部分 (Base64编码后的字符串) - 对应解码后的 "a0240.b002493.c00004027."
            const spmFixedBase64 = 'YTAyNDAuYjAwMjQ5My5jMDAwMDQwMjcu';

            // 生成变化部分：将 "数字#sku_card" 进行Base64编码
            // 注意：这里需要先对 "#" 进行URL编码为 "%23"，然后对整个字符串进行Base64编码
            const dynamicPart = `${position}浙江杭州`; // 例如 "5%23sku_card"
            const dynamicPartBase64 = btoa(dynamicPart); // Base64编码

            // 拼接完整的spmTag
            const spmTag = spmFixedBase64 + dynamicPartBase64;

            // 2. 生成 pvid (32位随机十六进制字符串)
            const generateRandomHex = (length) => {
                const chars = '0123456789abcdef';
                let result = '';
                for (let i = 0; i < length; i++) {
                    result += chars[Math.floor(Math.random() * chars.length)];
                }
                return result;
            };
            const pvid = generateRandomHex(32);

            // 3. 返回拼接好的参数字符串
            return `spmTag=${spmTag}&pvid=${pvid}`;
        },
        showAddressDialog() {
            // 使用nextTick确保父弹窗完全打开
            this.$nextTick(() => {
                this.$refs.jdAddressListDelivery.openDialog();
            });
        },
        handleAddressUpdate(newAddresses) {
            this.selectedAddresses = newAddresses;
            this.selectionGoods.addressMapList = this.selectedAddresses;
            this.getList(); // 直接触发列表刷新
        },
        async viewPriceTrend(item) {
            let {data} = await getGoodsPriceTrendApi({skuId: item.skuId});
            this.chartData = {
                ...data,
                skuName: item.title
            };
            this.chartDialogVisible = true;
        },
        chartDialogVisibleFn(val) {
            this.chartDialogVisible = val;
        },
        /**
         * 修改表格颜色
         */
        handleCommand(command) {
            const row = this.scope?.row; // 确保能拿到行的数据
            switch (command) {
                case "setSort":
                    this.setSort(row); // 执行修改顺序操作
                    break;
                case "viewPriceTrend":
                    // 执行查看价格趋势的操作
                    break;
                case "delGoods1":
                    this.delGoods(row, 1); // 执行删除当前库该商品的操作
                    break;
                case "delGoods2":
                    this.delGoods(row, 2); // 执行删除所有库该商品的操作
                    break;
            }
        },
        //  放大图片
        getSrcList(cardPicUrl) {
            if (cardPicUrl) {
                return cardPicUrl.split(',');
            }
        },
        checkClickUrl(item) {
            if (!item) {
                return;
            }
            const newWindow = window.open(item.jdUrl, '_blank');

            // 设定一个定时器，检查新页面的 URL 是否被重定向
            const checkRedirect = setInterval(() => {
                try {
                    let currentUrl = newWindow.location.href;
                    // 如果新窗口已经加载并且 URL 改变
                    if (currentUrl.includes('https://trade.m.jd.com/common/limit.html?module=detail_m1')) {
                        console.log('重定向到指定页面')
                        // 如果重定向到指定页面，执行特定操作
                        clearInterval(checkRedirect);
                        this.editDisPrice(item);
                    }
                    console.log('当前页面的 URL:', newWindow.location.href)
                } catch (e) {
                    // 浏览器的跨域限制可能会阻止访问 location.href
                    // 在跨域时，允许进行轮询，直到可以访问新窗口的 location 或者关闭
                    // 代表被重定向了 直接调用相关方法
                    clearInterval(checkRedirect);
                    this.editDisPrice(item);
                }

                // 如果新窗口关闭，停止轮询
                if (newWindow.closed) {
                    clearInterval(checkRedirect);
                }
            }, 1000); // 每秒检测一次
        },
        async editDisPrice(item) {
            let skuIdList = item;
            if (this.selectGoods) {
                skuIdList = this.selectGoods.map(item => item.skuId);
            }
            let requestData = {
                "skuIdList": skuIdList
            };
            // await editDisPriceApi({skuId: item.skuId});
            await editDisPriceApi(requestData);
            this.getList();
        },
        //  修改价格
        editRate() {
            if (this.rate) {
                this.rate = Number(this.rate);
                // this.getList();
                this.systemRate = (Number(this.selectGoods[0].supplPrice) / (Number(this.selectGoods[0].supplPrice) * this.rate)).toFixed(3)
                return;
            }
            if (this.jdRate) {
                this.jdRate = Number(this.jdRate);
                // this.getList();
                // this.systemRate = (this.selectGoods[0].disPrice / (this.selectGoods[0].disPrice * this.rate)).toFixed(3)
            }
        },
        // 打开商品的京东链接
        openLink() {
            this.linkLoading = true;
            const that = this;
            const baseUrl = 'https://item.jd.com/';

            // 如果没有商品，直接返回
            if (this.selectGoods.length === 0) {
                this.linkLoading = false;
                return;
            }

            let currentIndex = 0;
            let batchCount = 0; // 当前批次计数器
            const BATCH_SIZE = 50; // 每批数量
            const BATCH_BREAK_TIME = 30 * 60 * 1000; // 批次间休息时间30分钟

            // 生成京东商品链接（带参数）
            function generateJdItemUrl(skuId, position) {
                // 生成跟踪参数
                const params = that.generateJdUrlParams(position);
                // 拼接完整链接
                return `${baseUrl}${skuId}.html?${params}`;
            }

            function openNextLink() {
                if (currentIndex >= that.selectGoods.length) {
                    console.log("所有链接已打开完成");
                    that.linkLoading = false;
                    return;
                }

                // 检查是否需要批次休息
                if (batchCount >= BATCH_SIZE) {
                    console.log(`已完成 ${BATCH_SIZE} 个链接，暂停 ${BATCH_BREAK_TIME/1000/60} 分钟`);
                    that.$message.info(`已完成 ${BATCH_SIZE} 个链接，暂停 ${BATCH_BREAK_TIME/1000/60} 分钟`);

                    // 重置批次计数器
                    batchCount = 0;

                    // 休息半小时后继续
                    setTimeout(() => {
                        console.log("休息结束，继续打开链接");
                        that.$message.success("休息结束，继续打开链接");
                        openNextLink();
                    }, BATCH_BREAK_TIME);

                    return;
                }

                const currentSku = that.selectGoods[currentIndex]?.skuId;
                // 生成带参数的京东链接
                const currentLink = generateJdItemUrl(currentSku, currentIndex + 1);

                console.log(`正在打开第 ${currentIndex + 1}/${that.selectGoods.length} 个链接 (批次: ${batchCount + 1}/${BATCH_SIZE}): ${currentLink}`);

                // 打开商品详情页
                const productWindow = window.open(currentLink, '_blank');

                // 检查窗口是否被阻止
                if (!productWindow) {
                    console.log("窗口弹出被阻止，跳过此链接");
                    that.$message.error("窗口弹出被阻止，已跳过当前链接");

                    // 仍然计数，但跳过此链接
                    currentIndex++;
                    batchCount++;
                    scheduleNext();
                    return;
                }

                // 滚动新窗口
                try {
                    setTimeout(() => {
                        if (!productWindow.closed) {
                            productWindow.scrollTo(0, Math.random() * 10000);
                        }
                    }, 3000);
                } catch (e) {
                    console.error("无法滚动新窗口:", e);
                }

                // 检查重定向
                const checkRedirect = setInterval(() => {
                    try {
                        const currentUrl = productWindow.location.href;
                        if (currentUrl.includes('https://trade.m.jd.com/common/limit.html?module=detail_m1')) {
                            clearInterval(checkRedirect);
                            if (currentSku) {
                                that.editDisPrice({skuId: currentSku});
                            }
                        }
                    } catch (e) {
                        // 跨域错误，处理重定向
                        clearInterval(checkRedirect);
                        if (currentSku) {
                            that.editDisPrice({skuId: currentSku});
                        }
                    }

                    if (productWindow.closed) clearInterval(checkRedirect);
                }, 3000);

                // 更新计数器
                currentIndex++;
                batchCount++;

                // 安排下一个链接的打开
                scheduleNext();
            }

            function scheduleNext() {
                if (currentIndex >= that.selectGoods.length) {
                    that.linkLoading = false;
                    console.log("所有链接已处理完成");
                    return;
                }

                // 检查是否需要批次休息（在打开下一个之前检查）
                if (batchCount >= BATCH_SIZE) {
                    // 批次休息逻辑已在 openNextLink 中处理
                    return;
                }

                // 生成1到5分钟的随机延迟（毫秒）
                const minDelay = 1 * 60 * 1000; // 1分钟
                const maxDelay = 5 * 60 * 1000; // 5分钟
                const randomDelay = Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;

                const minutes = Math.round(randomDelay/1000/60*100)/100;
                console.log(`下一个链接将在 ${minutes} 分钟后打开 (批次进度: ${batchCount}/${BATCH_SIZE})`);

                setTimeout(() => {
                    openNextLink();
                }, randomDelay);
            }

            // 开始第一个链接
            openNextLink();

            // 保持当前窗口焦点
            window.focus();
        },
        tableRowClassName({row}) {

            if (row.deliveryStatus) {
                const hasError = Object.values(row.deliveryStatus).some(
                    status => !status.canPurchase
                );
                return hasError ? 'warning-row' : '';
            }
            // if ((this.item.staffId === 2 && row.fromTopicId === 3) || (this.item.staffId === 3 && row.fromTopicId === 4)) {
            //     return 'exit-row';
            // }

            if (row.status == 2) {
                return 'success-row';
            }

            if (((Number(row.supplPrice) * Number(this.rate)) > Number(row.price) * Number(this.jdRate)) || (Number(row.supplPrice) >= Number(row.price) * Number(this.jdRate))) {
                return 'success-row';
            }

            if (((Number(row.supplPrice) * Number(this.rate)) > Number(row.price)) || (Number(row.supplPrice) >= Number(row.price))) {
                return 'warning-row';
            }

        },
        provinceChange(id) {
            this.findBackendJdRegion("cityList", id);
            this.addressObj.cityId = ""
            this.addressObj.countyId = ""
            this.addressObj.townId = ""
            this.addressList.cityList = []
            this.addressList.countyList = []
            this.addressList.townList = []
        },
        cityChange(id) {
            this.findBackendJdRegion("countyList", id);
            this.addressObj.countyId = ""
            this.addressObj.townId = ""
            this.addressList.countyList = []
            this.addressList.townList = []
        },
        countyChange(id) {
            this.findBackendJdRegion("townList", id);
            this.addressObj.townId = ""
            this.addressList.townList = []
        },
        addressDialogOpen() {
            this.addressObj.provinceId = localStorage.getItem("provinceId") || ""
            this.addressObj.cityId = localStorage.getItem("cityId") || ""
            this.addressObj.countyId = localStorage.getItem("countyId") || ""
            this.addressObj.townId = localStorage.getItem("townId") || ""

            this.findBackendJdRegion("provinceList", 0);
            if (this.addressObj.provinceId) {
                this.findBackendJdRegion("cityList", this.addressObj.provinceId);
            }
            if (this.addressObj.cityId) {
                this.findBackendJdRegion("countyList", this.addressObj.cityId);
            }
            if (this.addressObj.countyId) {
                this.findBackendJdRegion("townList", this.addressObj.countyId);
            }
        },
        async findBackendJdRegion(type, id) {
            let {data} = await findBackendJdRegionApi({
                id
            })
            this.addressList[type] = data
        },
        /**
         * 设置发货地址
         */
        async setJdAddress() {
            if (this.addressObj.provinceId) {
                localStorage.setItem("provinceId", this.addressObj.provinceId)
            }
            if (this.addressObj.cityId) {
                localStorage.setItem("cityId", this.addressObj.cityId)
            }
            if (this.addressObj.countyId) {
                localStorage.setItem("countyId", this.addressObj.countyId)
            }
            if (this.addressObj.townId) {
                localStorage.setItem("townId", this.addressObj.townId)
            }
            this.addressDialog = false
            this.$message({
                type: 'success',
                message: '保存成功!'
            });
            this.getList();
        },
        /**
         * 导出文件
         */
        async exportExcel() {
            this.excelLoading = true;
            const response = await exportExcelApi({
                topicId: this.item.id,
                current: 1,
                size: 10,
                isJd: 1
            })
            const blob = new Blob([response], {type: 'application/octet-stream'});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${sd.format(new Date())}_已选商品.xlsx`; // 设置下载的文件名，根据需要修改
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            this.excelLoading = false;
        },
        /**
         * 批量删除商品
         */
        batchDelGoods() {
            this.$confirm('确定删除已选商品', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                for (const e of this.idArr) {
                    await deleteGoodsApi({
                        goodsId: e,
                        topicId: this.item.id,
                        removeType: 1,
                        isJd: 1
                    })
                }
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.queryGetList();
            })
        },
        /**
         * 删除已选商品
         */
        async delGoods(item, removeType) {
            if (removeType === 1) {
                await this.$confirm('确定删除当前库中该商品', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    await deleteGoodsApi({
                        goodsId: item.id,
                        topicId: this.item.id,
                        removeType: removeType,
                        isJd: item.isJd
                    })
                })
            } else if (removeType === 2) {
                await this.$confirm('确定删除所有库中该商品', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    await deleteGoodsApi({
                        goodsId: item.id,
                        topicId: this.item.id,
                        removeType: removeType,
                        isJd: item.isJd
                    })
                })
            }
            /*await deleteGoodsApi({
                goodsId: item.id,
                topicId: this.item.id
            })
            ;*/
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
            this.queryGetList();
        },
        async editPrice(item) {
            try {
                // 弹出输入框，预填当前价格
                const { value: newPrice } = await this.$prompt('请输入新的市场价', '修改价格', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^\d+(\.\d{1,2})?$/, // 验证数字格式（整数或两位小数）
                    inputErrorMessage: '请输入有效的价格（如：99.99）',
                    inputValue: item.price || '' ,// 预填当前价格（根据实际字段调整）
                    customClass: 'large-price-prompt', // 添加自定义类名
                });

                // 调用修改价格的API（替换原来的删除API）
                await updateMarketPriceApi({
                    goodsId: item.skuId,
                    topicId: this.item.id,
                    marketPrice: newPrice, // 传入新价格
                    isJd: item.isJd
                });

                this.$message.success('价格修改成功!');
                this.queryGetList(); // 刷新列表
            } catch (error) {
                // 用户点击取消或验证失败
                if (error === 'cancel' || error === 'close') return;

                // 处理API错误
                this.$message.error('修改失败: ' + (error.response?.data?.message || error.message));
                console.error('修改价格失败:', error);
            }
            /*await this.$confirm('确定删除当前库中该商品', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                await deleteGoodsApi({
                    goodsId: item.id,
                    topicId: this.item.id,
                    removeType: removeType,
                    isJd: item.isJd
                })
            })

            this.$message({
                type: 'success',
                message: '修改成功!'
            });
            this.queryGetList();*/
        },
        /**
         * 获取选择商品ID
         * @param val
         */
        handleSelectionChange(val) {
            this.idArr = val.map(item => item.id)
        },
        /**
         * 修改排序
         */
        setSort(item) {
            this.$prompt('请输入排序号', '修改排序', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: item.sort
            }).then(async ({value}) => {
                let obj = {
                    goodsId: item.id,
                    sort: value,
                    topicId: this.item.id
                }
                await updateSortApi(JSON.stringify(obj));
                this.queryGetList()
            })
        },
        async setTopicGoodsDisPrice(item) {
            this.$prompt('请输入排序号', '修改排序', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: item.disPrice
            }).then(async ({value}) => {
                let obj = {
                    goodsId: item.id,
                    disPrice: value,
                    disPriceType: 1,
                    topicId: this.item.id
                }
                await updateTopicGoodsDisPriceApi(JSON.stringify((obj)));
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                this.queryGetList()
            })
        },
        /**
         * 清空选品库
         */
        clearSelGoods() {
            this.$confirm('确定清空当前选品库吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let {data} = await clearTopicApi({
                    id: this.selectionGoods.topicId
                })
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.queryGetList();
            })
        },
        /**
         * 切换列表
         */
        switchGoods(index) {
            this.index = index;
            if (index === 1) {
                this.queryGetList();
            } else {
                this.$emit("SwithGoods", index)
            }
        },
        /**
         * 分页大小切换时触发
         * @param val
         */
        handleSizeChange(val) {
            this.selectionGoods.size = val;
            this.getList();
        },
        /**
         * 页码切换时触发
         * @param val
         */
        handleCurrentChange(val) {
            this.selectionGoods.current = val;
            this.getList();
        },
        /**
         * 评论类型
         */
        commentType() {
            return commentType
        },
        /**
         * 条件查询
         */
        queryGetList(isJd) {
            this.getList(isJd)
        },

        /**
         * 查询
         */
        async getList(isJd) {
            this.loading = true;
            if (isJd) {
                this.selectionGoods.isJd = isJd
            }
            let config = {
                ...this.selectionGoods,
                // sortOrder:this.selectionGoods.sortOrder ? this.selectionGoods.sortOrder.join(',') : ''
            }
            let obj = JSON.parse(JSON.stringify(config));
            ObjectUtil.removeEmptyValues(obj)
            let {data: res} = await getSelectedPageApi(obj)

            this.skuListFiler = []
            /*if (localStorage.getItem("provinceId")) {
                let list = []
                res.rows.forEach(r => {
                    list.push(r.skuId)
                })
                this.addressObj.provinceId = localStorage.getItem("provinceId") || ""
                this.addressObj.cityId = localStorage.getItem("cityId") || ""
                this.addressObj.countyId = localStorage.getItem("countyId") || ""
                this.addressObj.townId = localStorage.getItem("townId") || ""
                let {data} = await getGoodsDetailByIdsApi({
                    provinceId: this.addressObj.provinceId,
                    cityId: this.addressObj.cityId,
                    countyId: this.addressObj.countyId,
                    townId: this.addressObj.townId,
                    skuIdList: list.join(",")
                })
                data.forEach((r, index) => {
                    let arr = JSON.parse(r);
                    arr.forEach((item) => {
                        res.rows[index].addressStatus = item.areaRestrict
                    })
                })
            }*/
            this.selectGoods = res.rows;
            let {data} = await getSelectedTotalApi(obj)
            this.total = data
            this.loading = false;
        },
        /**
         * 初始化组件
         */
        open(item) {
            this.item = item;
            this.selectionGoods.current = 1;
            this.selectionGoods.topicId = item.id;
            this.dialog = true;
            this.initCategory(item.id);
            this.queryGetList()
        },
        /**
         * 初始化分类
         */
        async initCategory(topicId) {
            // let {data} = await getCategoryListApi();
            let {data} = await getCategoryListByTopicApi({topicId: topicId});
            this.categoryId1 = data.categoryList;
        },
        /**
         * 获取二级分类
         */
        async getCategory1List() {
            // let {data} = await getCategory1ListApi({
            //     name: this.selectionGoods.categoryId1Name, categoryLevel: 1
            // });
            let {data} = await getCategory1ListByTopicApi({
                name: this.selectionGoods.categoryId1Name, categoryLevel: 1, topicId: this.item.id
            });
            this.selectionGoods.categoryId2Name = ""
            this.categoryId2 = data.categoryList;
            this.queryGetList()
        },
        /**
         * 切换商品货源
         */
        isJdChange() {
            this.selectionGoods.current = 1;
            this.queryGetList()
        },
        /**
         * 重置
         */
        reset() {
            this.selectionGoods = {
                commentType: "",
                goodsId: "",
                current: 1,
                size: 10,
                total: 999,
                isJd: 1,
                title: "",
                categoryId1Name: "",
                categoryId2Name: "",
                level: "",
                phone: "",
                minSupplyPrice: "",
                maxSupplyPrice: "",
                minProfitMargin: "",
                maxProfitMargin: "",
            }
            this.queryGetList();
        }
    },
    mounted() {
        this.open(this.items);
    }
}